export default {
  allCell: {
    width: '60px'
  },
  all: {
    width: '30px'
  },
  dateCell: {
    width: '120px',
    textAlign: 'left'
  },
  date: {
    width: '40px'
  },
  title: {
    width: '40px'
  },
  titleCell: {
    textAlign: 'left'
  },
  ageGroupCell: {
    textAlign: 'center',
    width: '140px'
  },
  ageGroup: {
    width: '80px'
  },
  publishedCell: {
    width: '120px'
  },
  published: {
    width: '75px'
  },
  contextMenuCell: {
    width: '60px'
  },
  bulkAction: {
    display: 'block',
    height: '40px',
    width: '93px',
    borderRadius: '4px'
  },
  thumbnailCell: {
    width: '100px'
  },
  thumbnail: {
    width: '40px'
  },
  staCell: {
    width: '140px'
  },
  sta: {
    width: '90px'
  }
}
